import styled from 'styled-components';
import { COLORS } from '../../../styles/Colors';

// Container principali
export const SidebarContainer = styled.div`
  position: fixed;
  top: 0;
  right: ${props => props.isOpen ? '0' : '-400px'};
  width: 400px;
  height: calc(100vh - 70px);
  background: white;
  box-shadow: -2px 0 10px rgba(0,0,0,0.1);
  z-index: 2000;
  overflow-y: auto;
  transition: right 0.3s ease;
  padding: 0;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 768px) {
    width: 100%;
    height: 100vh;
    right: ${props => props.isOpen ? '0' : '-100%'};
    overflow-y: auto;
    padding-bottom: 70px; /* Ridotto da 120px a 70px */
  }
`;


export const SidebarHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
  
  @media (max-width: 768px) {
    position: static; /* NON sticky su mobile - deve scorrere */
    border-bottom: none;
    padding-bottom: 10px;
  }
`;

export const SidebarContent = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 20px;
  
  @media (max-width: 768px) {
    padding: 0 20px 20px 20px; /* Rimuovi padding top su mobile */
    overflow-y: visible; /* Non serve overflow separato su mobile */
  }
`;

export const SidebarOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1999;
  display: ${props => props.isOpen ? 'block' : 'none'};
  
  @media (min-width: 769px) {
    display: none;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 16px;
  color: #666;
`;

// Componenti evento
export const EventTitle = styled.h2`
  font-size: 24px;
  margin: 0 0 10px 0;
  padding-right: 30px;
  color: ${COLORS.text};
  `;

export const EventDate = styled.div`
  font-size: 16px;
  color: ${COLORS.textLight};
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 8px;
`;

export const EventLocation = styled.div`
  font-size: 16px;
  color: ${COLORS.textLight};
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const CategoryTag = styled.span`
  background: ${COLORS.backgroundLight};
  color: ${COLORS.secondary};
  padding: 5px 10px;
  border-radius: 15px;
  font-size: 13px;
  border: 1px solid ${COLORS.border};
`;

export const CategoryTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 15px;
`;

export const InfoTitle = styled.h3`
  font-size: 18px;
  margin: 0 0 15px 0;
  color: ${COLORS.secondary};
`;

export const InfoSection = styled.div`
  margin: 25px 0;
  border-top: 1px solid #f0f0f0;
  padding-top: 20px;
`;

export const InfoItem = styled.div`
  margin-bottom: 15px;
  
  strong {
    display: block;
    margin-bottom: 5px;
    color: #666;
  }
`;

// Pulsanti - VERSIONE MODIFICATA
export const BackToMapButton = styled.button`
  background: #f39c12;
  color: white;
  border: none;
  padding: 12px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.3s;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  &:hover {
    background: #e67e22;
  }
  
  @media (max-width: 768px) {
    order: 3;
    flex: 0 0 auto; /* Non si espande su mobile */
    padding: 12px;
    border-radius: 8px;
    min-width: 50px;
    
    /* Nascondi il testo su mobile, mostra solo l'icona */
    .button-text {
      display: none;
    }
    
    .button-icon {
      font-size: 20px;
    }
  }
`;

export const DirectionsButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: ${COLORS.secondary};
  color: white;
  text-decoration: none;
  padding: 12px 15px;
  border-radius: 4px;
  font-weight: 500;
  transition: background 0.3s;
  flex: 1;
  
  &:hover {
    background: ${COLORS.secondaryLight};
  }
  
  @media (max-width: 768px) {
    order: 2;
    flex: 0 0 auto; /* Non si espande su mobile */
    padding: 12px;
    border-radius: 8px;
    min-width: 50px;
    
    /* Nascondi il testo su mobile, mostra solo l'icona */
    .button-text {
      display: none;
    }
    
    .button-icon {
      font-size: 20px;
    }
  }
`;

export const InterestedButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: ${props => props.isInterested ? '#e74c3c' : '#27ae60'};
  color: white;
  border: none;
  padding: 12px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s;
  flex: 1;
  position: relative;
  
  &:hover {
    background: ${props => props.isInterested ? '#c0392b' : '#229954'};
    transform: translateY(-1px);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
  
  @media (max-width: 768px) {
    order: 1;
    flex: 0 0 auto; /* Non si espande su mobile */
    padding: 12px;
    border-radius: 8px;
    min-width: 50px;
    position: relative;
    
    /* Nascondi il testo su mobile, mostra solo l'icona */
    .button-text {
      display: none;
    }
    
    .button-icon {
      font-size: 20px;
    }
  }
`;

export const InterestCounter = styled.span`
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 12px;
  margin-left: 4px;
  
  @media (max-width: 768px) {
    position: absolute;
    top: -8px;
    right: -8px;
    background: #fff;
    color: #333;
    font-size: 10px;
    min-width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-left: 0;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }
`;

export const SidebarFooter = styled.div`
  padding: 15px 20px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  
  @media (max-width: 768px) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
    flex-direction: row; /* Cambiato da column a row */
    justify-content: center; /* Centra i pulsanti */
    gap: 15px; /* Spazio tra i pulsanti */
    z-index: 11;
    padding: 12px 20px; /* Ridotto il padding verticale */
  }
`;

// Aggiungi questi nuovi styled components per le icone
export const ButtonIcon = styled.span`
  font-size: 16px;
  
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const ButtonText = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`;

// Descrizione espandibile
export const ExpandableDescription = styled.div`
  margin: 20px 0;
  line-height: 1.6;
  color: #333;
  position: relative;
`;

export const DescriptionText = styled.div`
  transition: all 0.3s ease;
  position: relative;
  
  ${props => !props.isExpanded ? `
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.4;
  ` : `
    line-height: 1.4;
  `}
  
  ${props => !props.isExpanded && `
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 20px;
      background: linear-gradient(transparent, white);
      pointer-events: none;
    }
  `}
`;


export const ExpandButton = styled.button`
  background: none;
  border: none;
  color: ${COLORS.secondary};
  font-weight: 500;
  cursor: pointer;
  padding: 8px 0;
  margin-top: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  transition: color 0.3s ease;
  
  &:hover {
    color: ${COLORS.primary};
    text-decoration: underline;
  }
`;

// Slider componenti
export const CoverSliderSection = styled.div`
  width: 100%;
  height: 250px;
  margin-bottom: 20px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  
  @media (max-width: 768px) {
    height: 200px;
    margin-bottom: 15px;
    border-radius: 0; /* Rimuovi border radius su mobile per occupare tutto lo spazio */
    margin-bottom: 0; /* Rimuovi margin bottom su mobile */
  }
`;

export const SliderContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
`;

export const SliderImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  opacity: ${props => props.isActive ? 1 : 0};
  transition: opacity 0.5s ease;
  cursor: pointer;
`;

export const SliderControls = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  pointer-events: none;
`;

export const SliderButton = styled.button`
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  pointer-events: auto;
  transition: background 0.3s ease;
  
  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
  
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const SliderIndicators = styled.div`
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
`;

export const SliderDot = styled.button`
  width: 10px;
  height: 10px;
  border-radius: 50%;
    border: none;
  background: ${props => props.isActive ? 'white' : 'rgba(255, 255, 255, 0.5)'};
  cursor: pointer;
  transition: background 0.3s ease;
  
  &:hover {
    background: white;
  }
`;

export const SliderOverlay = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 8px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
`;

// Modal componenti
export const ImageModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  padding: 20px;
`;

export const ModalImage = styled.img`
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  border-radius: 8px;
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  
  &:hover {
    background: white;
  }
`;

export const LastUpdateInfo = styled.div`
  padding: 15px 20px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: center;
  font-size: 12px;
  color: #999;
  
  @media (max-width: 768px) {
    margin-bottom: 20px; /* Aggiunge spazio per i pulsanti fissi */
    border-top: none;
  }
`;

// Contenitore scrollabile per mobile
export const MobileScrollContainer = styled.div`
  @media (max-width: 768px) {
    height: calc(100vh - 100px); /* Altezza totale meno spazio pulsanti */
    overflow-y: auto;
    -webkit-overflow-scrolling: touch; /* Smooth scrolling su iOS */
  }
`;
// Aggiungi questo nuovo styled component
export const ClickableOrganizer = styled.span`
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
  margin-left: 8px;
  
  &:hover {
    color: #0056b3;
    text-decoration: none;
  }
  
  &:active {
    color: #004085;
  }
`;

